import { Box, Text, Image, Collapsible, Button, Layer } from "grommet";
import { Close, Home, HomeRounded, StatusInfo } from "grommet-icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import { MdEventNote, MdPersonSearch, MdLibraryBooks } from "react-icons/md";
import { FaSchool } from "react-icons/fa";
import SearchPerson from "../shared_comp/SearchPerson";
import SearchSchool from "../shared_comp/SearchSchool";
import SearchBook from "../shared_comp/SearchBook";
import SearchPersonModal from "../modals/SearchPersonModal";
const ArchiveMain = () => {
    let navigate = useNavigate();
    const gotoMenu = (menu: any) => {
        // console.log(menu)
        navigate("/archive/" + menu);
    };
    let menu_gov = [
        { name: "통계연보", menu: "statistics", status: "toc" },
        { name: "조선제학교일람", menu: "catalogue", status: "toc" },
        { name: "법률", menu: "law", status: "toc" },
        { name: "서임급사령", menu: "gazette", status: "toc" },
        { name: "기타정부문서", menu: "document", status: "preparing" },
    ];
    let menu_reference = [
        { name: "교우회지", menu: "bulletin", status: "book" },
        { name: "졸업앨범", menu: "album", status: "book" },
        { name: "동창회원명부", menu: "alumni", status: "book" },
        { name: "학교출간물", menu: "schoolcatalogue", status: "book" },
        { name: "회고록", menu: "biography", status: "list" },
        { name: "잡지", menu: "magazine", status: "preparing" },
        { name: "신문", menu: "newspaper", status: "preparing" },
        { name: "기타", menu: "etc", status: "preparing" },
    ];
    let menu_research = [
        { name: "학위논문", menu: "thesis", status: "list" },
        { name: "학술논문", menu: "article", status: "preparing" },
        { name: "단행본", menu: "book", status: "list" },
    ];

    const IntroArchive = () => {
        return (
            <Box
                background="rgb(255,255,255,0.8)"
                margin="30px"
                pad="30px"
                flex="grow"
            >
                <Text size="13px" margin="5px">
                    한국교원대학교 교육박물관 ‘한국근대교육사자료서비스’는 한국
                    근대 교육사 자료를 제공하는 웹 사이트로 한국근대교육사
                    연구의 토대를 마련하고 자료를 공유하기 위해 만들어졌습니다.
                </Text>
                <Text size="13px" margin="5px">
                    본 자료서비스는 대한민국 교육정보 허브를 구축하는
                    한국교원대학교의 장기 발전 전략 아래 추진중입니다.
                </Text>
                <Text size="13px" margin="5px">
                    현재 자료서비스는 한국연구재단의 인문사회연구소
                    지원사업(2019~)으로 진행되는
                </Text>
                <Text size="13px" margin="5px">
                    (1) 조선제학교일람을 통한 학교 정보
                </Text>
                <Text size="13px" margin="5px">
                    (2) 경기도보의 서임급사령에서 추출한 교원 정보
                </Text>
                <Text size="13px" margin="5px">
                    (3) 회고록에 등장한 교육경험 수집에서 축적된 정보를
                    우선적으로 제공하며,
                </Text>
                <Text size="13px" margin="5px">
                    향후 법률, 신문 및 잡지, 등 다양한 정보를 추가할 예정입니다.
                </Text>
            </Box>
        );
    };
    const [open, setOpen] = React.useState(false);

    const optColorNot = "rgb(255,255,255,0.7)";

    const MenuBox = (props: any) => (
        <Box
            align="start"
            justify="center"
            direction="row"
            margin={{ top: "30px" }}
            background="rgb(0,0,0,0.01)"
            flex="grow"
        >
            <Box align="end" justify="center" width="50%">
                <Text margin="10px" size="17px" color="white">
                    {props.title}
                </Text>
            </Box>
            <Box direction="column" margin={{ top: "7px" }} width="50%">
                {props.menulist.map((v: any) => (
                    <Box
                        key={v.menu}
                        direction="row"
                        align="center"
                        focusIndicator={false}
                        onClick={() => gotoMenu(v.menu)}
                    >
                        <Text
                            margin="5px"
                            size="15px"
                            color={
                                v.status === "preparing" ? optColorNot : "white"
                            }
                            weight={
                                v.status === "preparing" ? "normal" : "bold"
                            }
                        >
                            {v.name}
                        </Text>
                        {v.status === "preparing" && (
                            <Text size="8px" color="white">
                                - 준비중
                            </Text>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
    const TroisElement = (props: any) => (
        <Box
            {...props}
            width="90%"
            background="rgb(0,0,0,0.05)"
            pad={{ vertical: "10px", horizontal: "20px" }}
            direction="column"
        ></Box>
    );
    const [searchSubject, setSearchSubject] = React.useState(false);
    const [searchSchool, setSearchSchool] = React.useState(false);
    const [searchBook, setSearchBook] = React.useState(false);
    React.useEffect(() => {
        setSearchSubject(false);
        setSearchSchool(false);
        setSearchBook(false);
    }, []);

    const Subject = () => (
        <TroisElement>
            <Box
                direction="row"
                align="center"
                justify="center"
                onClick={() => setSearchSubject(true)}
                focusIndicator={false}
                hoverIndicator
            >
                <Box
                    direction="row"
                    align="center"
                    justify="center"
                    width="150px"
                >
                    <MdPersonSearch size="30px" color="white" />
                    <Text size="20px" color="white" margin="10px" weight="bold">
                        인물
                    </Text>
                </Box>

                {/* <SearchPerson /> */}
            </Box>
        </TroisElement>
    );
    const Space = () => (
        <TroisElement>
            <Box
                direction="row"
                align="center"
                justify="center"
                onClick={() => setSearchSchool(true)}
                focusIndicator={false}
                hoverIndicator
            >
                <Box
                    direction="row"
                    align="center"
                    justify="center"
                    width="150px"
                >
                    <FaSchool size="30px" color="white" />
                    <Text size="20px" color="white" margin="10px" weight="bold">
                        학교
                    </Text>
                </Box>
                {/* <SearchSchool /> */}
            </Box>
        </TroisElement>
    );

    const Book = () => (
        <TroisElement>
            <Box
                direction="row"
                align="center"
                justify="center"
                onClick={() => setSearchBook(true)}
                focusIndicator={false}
                hoverIndicator
            >
                <Box
                    direction="row"
                    align="center"
                    justify="center"
                    width="150px"
                >
                    <MdLibraryBooks size="30px" color="white" />
                    <Text size="20px" color="white" margin="10px" weight="bold">
                        자료
                    </Text>
                </Box>
                {/* <SearchBook /> */}
            </Box>
        </TroisElement>
    );

    return (
        <Box
            direction="column"
            width="full"
            margin="10px"
            height="99%"
            overflow={"auto"}
        >
            <Box
                direction="row"
                align="center"
                justify="center"
                margin={{ bottom: "20px" }}
            >
                <Text size="28px" color="white" margin="5px" weight="bold">
                    한국 근현대 교육사 자료서비스
                </Text>
            </Box>
            <Box
                align="center"
                justify="center"
                alignSelf="center"
                direction="row"
            >
                <Subject />
                {/* <Space /> */}
                {/* <Book /> */}
            </Box>
            {searchSubject && (
                <Box
                    direction="column"
                    background="rgba(255,255,255,0.5)"
                    alignSelf="center"
                    align="center"
                    justify="center"
                >
                    <Layer
                        onClickOutside={() => setSearchSubject(false)}
                        onEsc={() => setSearchSubject(false)}
                        modal
                        full
                    >
                        <Box align="start" justify="start" alignSelf="center" width="full" height='full'>
                            <Box
                                margin={{ top: "50px" }}
                                alignSelf="end"
                                hoverIndicator
                                focusIndicator={false}
                                onClick={() => setSearchSubject(false)}
                                height="50px"
                            >
                                <Button
                                    size="15px"
                                    icon={<Close size="15px" />}
                                    onClick={() => setSearchSubject(false)}
                                />
                            </Box>
                            <Box width="90%" height="80%" align="center" alignSelf="center">
                                <SearchPersonModal />
                            </Box>
                        </Box>
                    </Layer>
                </Box>
            )}
            {searchSchool && (
                <Layer
                    onClickOutside={() => setSearchSchool(false)}
                    onEsc={() => setSearchSchool(false)}
                    modal
                ></Layer>
            )}
            {searchBook && (
                <Layer
                    onClickOutside={() => setSearchBook(false)}
                    onEsc={() => setSearchBook(false)}
                    modal
                ></Layer>
            )}

            {/* <Book/> */}
            <Collapsible open={open}>
                <IntroArchive />
            </Collapsible>
            <Box overflow={"auto"}>
                <MenuBox title="정부자료" menulist={menu_gov} />
                <MenuBox title="참고자료" menulist={menu_reference} />
                <MenuBox title="연구동향" menulist={menu_research} />
            </Box>
        </Box>
    );
};
export default ArchiveMain;
